export const SearchesAndRequestDynamicCardAreaName = 'searchesAndRequests';
